import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';

import DotsLoading from '../../../components/dotsLoading';
import PrimaryCard from '../../../components/mazraeKit/cards/primaryCard';
import CustomSearchBox from '../../../components/mazraeKit/customSearchBox';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import useGetOffers from '../../../services/hookService/getOffers/useGetOffers';
import UseGetProfileCity from '../../../services/hookService/getProfileCityName/useGetProfileCity';
import {RootState} from '../../../store/redux';
import {findOffersBySearch} from '../../../store/redux/offers';
import useDebounce from '../../../utilities/hooks/useDebounce/useDebounce';
import FiltersOffersList from './filtersOffersList/FiltersOffersList';
import OffersListingBottomSheet from './offersListingBottomSheet';

const OffersListing = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState<string>('');
  const [openBottomSheet, setOpenBottomSheet] = useState(false);

  const debouncedValue = useDebounce(inputValue, 2000);

  useEffect(() => {
    dispatch(findOffersBySearch({search: inputValue}));
  }, [debouncedValue]);

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const {locational} = useSelector(
    (state: RootState) => state.searchingLocation,
  );
  const state = useSelector((state: RootState) => state.offers);
  const cities = locational.map(item => item.id).toString();

  const {amazingOffers, amazingOffersIsLoading} = useGetOffers({
    search: state.search || undefined,
    selected_cities_id: cities || undefined,
    input_guid: state.input_guid?.map(item => item.guid).join(',') || undefined,
    ordering: state.order_by || undefined,
    start_price: state.start_price || undefined,
    end_price: state.end_price || undefined,
    has_special_offer: true || undefined,
  });

  return (
    <div className="relative flex flex-col w-full h-full">
      <CustomHeader
        title="پیشنهادات شگفت انگیز"
        preIcon="icon-nameArrow---Right"
        onClick={() => navigate(-1)}
        isActiveRightIcon
      />
      <div className="flex flex-col w-full px-3 mt-2">
        <CustomSearchBox
          placeholder="جستجو در فروشگاه "
          type="text"
          value={inputValue}
          inputCustomClass="!pr-8"
          isFloating={false}
          preIcon="icon-nameSearch"
          onChange={onChangeHandler}
          removeIconClassName="!left-24"
          customComponent={() => (
            <div className="absolute left-0 flex items-center px-2 py-2 -translate-y-1/2 border-r-2 border-gray-100 top-1/2">
              <i className="text-xl icon-nameLocation" />
              <span
                className="text-sm"
                onClick={() =>
                  navigate('/choose-location', {
                    state: {from: location?.pathname},
                  })
                }
              >
                {locational?.length
                  ? `${locational?.length} شهرستان`
                  : UseGetProfileCity().profileCity}
              </span>
            </div>
          )}
          {...{inputValue, setInputValue}}
        />

        <div className="flex items-center w-full gap-2 py-2 mt-3 overflow-x-auto overflow-y-hidden">
          <button
            className="flex items-center gap-2 px-3 py-2 text-gray-700 border rounded-full w-fit"
            onClick={() => setOpenBottomSheet(true)}
          >
            <i className="font-bold icon-nameFilter text-xxl" />
            <span className="text-sm whitespace-nowrap">فیلتر کردن</span>
          </button>
          <div>
            <FiltersOffersList />
          </div>
        </div>
      </div>

      <div className="flex flex-col h-full gap-2 px-3 my-3 overflow-y-auto">
        {amazingOffersIsLoading ? (
          <DotsLoading />
        ) : (
          amazingOffers?.results.map(item => (
            <PrimaryCard {...item} cardSize="lg" />
          ))
        )}
      </div>
      <div className="flex flex-col gap-4 overflow-y-auto"></div>

      <OffersListingBottomSheet {...{openBottomSheet, setOpenBottomSheet}} />
      <MainFooter />
    </div>
  );
};

export default OffersListing;
